import { NotificationManagementVM } from 'practice/view-models/notification-management';
import { HeadCell } from 'shell/components/shared/table/types';
import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';

export const headCells: HeadCell<NotificationManagementVM, keyof NotificationManagementVM>[] = [
  {
    id: 'practiceId',
    label: 'Pratica',
  },
  {
    id: 'cf',
    label: 'Codice Fiscale',
  },
  {
    id: 'communicationId',
    label: 'Codice Comunicazione', // Codice notifica lo iun
  },
  {
    id: 'communicationType',
    label: 'Tipo Comunicazione', // Campo cdAmbito
  },
  {
    id: 'transmissionType',
    label: 'Tipo Trasmissione', // campo da aggiungere a BE
  },
  {
    id: 'trasmissionDate',
    label: 'Data trasmissione', // timestampInserimento
  },
  {
    id: 'state',
    label: 'Stato', // stato
  },
  {
    id: 'stateDate',
    label: 'Data stato', // timestampUltimoAggiornamento
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const validationSchemaFilter = yup.object({
  year: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  fromNumber: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  toNumber: yup.string().matches(regexOnlyNumber, 'Campo numerico'),
  transmissionDateFrom: yup.date().nullable().typeError('Data non valida'),
  transmissionDateTo: yup.date().nullable().typeError('Data non valida'),
  stateDateFrom: yup.date().nullable().typeError('Data non valida'),
  stateDateTo: yup.date().nullable().typeError('Data non valida'),
});
